<template>
  <a-spin :spinning="loading">
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Manage {{ school ? school.name : 'School' }}</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <a href="javascript:;" class="btn btn-sm btn-dark btn-with-addon"
            @click="handleBackButton"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-chevron-left" />
            </span>
            Back
          </a>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <div class="neo-tabs">
              <a-tabs :defaultActiveKey="1" :tabPosition="this.settings['isMobileView'] ? 'top' : 'left'"
              @change="handleTabChange"
              >
                <a-tab-pane :key="1">
                  <span slot="tab">
                    Payment Portal Settings
                  </span>
                  <div>
                    <PaymentGateway />
                  </div>
                </a-tab-pane>
                <a-tab-pane :key="2">
                  <span slot="tab">
                    School Modules
                  </span>
                  <div>
                    <SchoolModules />
                  </div>
                </a-tab-pane>
                <a-tab-pane :key="3">
                  <span slot="tab">
                    SMS Settings
                  </span>
                  <div>
                    <SmsSettings :reload="reloadSmsSettings" />
                  </div>
                </a-tab-pane>
                  <a-tab-pane :key="4">
                  <span slot="tab">
                    School Privacy Policy
                  </span>
                  <div>
                    <SchoolPrivacyPolicy />
                  </div>
                </a-tab-pane>
              </a-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { mapState } from 'vuex'
import PaymentGateway from '@/components/school/Manage/PaymentGateway/index'
import SchoolModules from '@/components/school/Manage/Modules/index'
import SmsSettings from '@/components/school/Manage/SMS/index'
import SchoolPrivacyPolicy from '@/components/schoolPrivacyPolicy/Main/index'

export default {
  components: {
    PaymentGateway,
    SchoolModules,
    SmsSettings,
    SchoolPrivacyPolicy,
  },
  computed: {
    schoolId: function () {
      return this.$route.params.id
    },
    ...mapState(['settings']),
  },
  mounted() {
    this.getSchool()
  },
  data: function() {
    return {
      loading: false,
      school: null,
      reloadSmsSettings: false,
    }
  },
  methods: {
    handleBackButton() {
      this.$router.push({ name: 'schools' })
    },
    getSchool() {
      this.loading = true
      this.$http.get(`/api/school/${this.schoolId}`)
        .then(({ data }) => {
          this.school = data.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$neoNotify.error(error)
        })
    },

    handleTabChange(value) {
      if (value === 3) {
        this.reloadSmsSettings = true
      } else {
        this.reloadSmsSettings = false
      }
    },
  },
}
</script>
